(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["of-header"]) return;
  try {
    
(function(){var src='https://www.offroad-fittery.de/cdn/shop/files/Logo_OF_HD.png';var im=new Image();im.crossOrigin='anonymous';im.onload=function(){try{var W=900,H=Math.round(900*im.naturalHeight/im.naturalWidth);var c=document.createElement('canvas');c.width=W;c.height=H;var x=c.getContext('2d');x.drawImage(im,0,0,W,H);var d=x.getImageData(0,0,W,H),p=d.data;for(var i=0;i<p.length;i+=4){var r=p[i],g=p[i+1],b=p[i+2],mn=Math.min(r,g,b),mx=Math.max(r,g,b);if(mn>222&&(mx-mn)<18){p[i+3]=0;}else if(mn>180&&(mx-mn)<25){p[i+3]=Math.round(255*(255-mn)/75);}}x.putImageData(d,0,0);var u=c.toDataURL('image/png');document.querySelectorAll('img.of-logo').forEach(function(el){el.src=u;el.style.mixBlendMode='normal';});}catch(e){}};im.src=src;
var h=document.querySelector('.of-header');if(h){var sh=function(){h.classList.toggle('of-shrink',window.scrollY>50);};window.addEventListener('scroll',sh,{passive:true});sh();}
document.addEventListener('open',function(e){var t=e.target;if(!t||!t.matches||!t.matches('shopify-account'))return;var b=Math.max(0,Math.round(t.getBoundingClientRect().bottom));t.style.setProperty('--account-dialog-top',b+'px');},true);
var mn=document.querySelector('.of-menu');if(mn){var place=function(it){var m=it.querySelector('.of-mega');if(!m)return;m.style.left='0px';var r=m.getBoundingClientRect();var pad=14;var over=r.right-(window.innerWidth-pad);if(over>0){var l=-over;var r2=it.getBoundingClientRect();if(r2.left+l<pad){l=pad-r2.left;}m.style.left=Math.round(l)+'px';}};Array.prototype.forEach.call(mn.querySelectorAll('.of-nav.has-sub'),function(it){it.addEventListener('mouseenter',function(){place(it);});it.addEventListener('focusin',function(){place(it);});});window.addEventListener('resize',function(){Array.prototype.forEach.call(mn.querySelectorAll('.of-mega'),function(m){m.style.left='0px';});},{passive:true});var close=function(){Array.prototype.forEach.call(mn.querySelectorAll('.of-nav.is-open'),function(n){n.classList.remove('is-open');});};if(window.matchMedia&&window.matchMedia('(hover:none)').matches){mn.addEventListener('click',function(e){var a=e.target&&e.target.closest?e.target.closest('.of-nav.has-sub>a'):null;if(!a)return;var it=a.parentNode;if(it.classList.contains('is-open'))return;e.preventDefault();close();place(it);it.classList.add('is-open');});document.addEventListener('click',function(e){if(!e.target||!e.target.closest||!e.target.closest('.of-menu'))close();});}document.addEventListener('keydown',function(e){if(e.key==='Escape'){close();var ae=document.activeElement;if(ae&&ae.closest&&ae.closest('.of-menu'))ae.blur();}});}
})();

  } catch(e) { console.error(e); }
})();
})();
